"use strict";
/**
 * Created by Marvn on 27.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// @ts-ignore
var react_tinymce_1 = __importDefault(require("react-tinymce"));
var TinyMCEComponent = function (_a) {
    var _b = _a.input, name = _b.name, value = _b.value, input = __rest(_b, ["name", "value"]), meta = _a.meta, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.inline, inline = _d === void 0 ? false : _d, props = __rest(_a, ["input", "meta", "disabled", "inline"]);
    if (disabled === true) {
        return (react_1["default"].createElement("div", { dangerouslySetInnerHTML: { __html: value }, className: "input-lookalike" }));
    }
    return (react_1["default"].createElement(react_tinymce_1["default"], __assign({}, props, { name: name, content: value, onBlur: function (e) { return input.onBlur(e.target.getContent()); }, config: {
            inline: inline,
            menubar: false,
            toolbar: 'bold italic underline | alignleft aligncenter alignright ',
            height: 150,
            statusbar: true
        } })));
};
exports["default"] = TinyMCEComponent;
